import { InputNumber } from "antd";

const CommonPercentageInput = ({ value, onChange, min = 0, max = 100 }) => {
  return (
    <div className="input_number" style={{ display: "flex", alignItems: "center", gap: "4px" }}>
      <InputNumber
        className="w-100"
        value={value}
        onChange={onChange}
        min={min}
        max={max}
        placeholder="Enter percentage"
        addonAfter="%"
      />
    </div>
  );
};

export default CommonPercentageInput;